import { render, staticRenderFns } from "./ResultBloodParasiteMaster.vue?vue&type=template&id=56c357c8&scoped=true"
import script from "./ResultBloodParasiteMaster.vue?vue&type=script&lang=js"
export * from "./ResultBloodParasiteMaster.vue?vue&type=script&lang=js"
import style0 from "./ResultBloodParasiteMaster.vue?vue&type=style&index=0&id=56c357c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c357c8",
  null
  
)

export default component.exports